import { useAllCaseVersionsCombinedWithTemplates } from "src/cases/queries/templates";

export const useCaseSchemaEditorState = () => {
  const { data: templatesData, isLoading: isLoadingTemplates } =
    useAllCaseVersionsCombinedWithTemplates();

  return {
    templatesData,
    isLoadingTemplates,
  };
};
